import Swiper, { Pagination } from "swiper";
import { gsap, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function initBlock() {



    if(!$('.block-ecommerce-benefits').length) { return false }

    if($(window).width() < 992) {
        $(window).on('load', function (e) {
            let swiper = new Swiper('.block-ecommerce-benefits .swiper', {
                modules: [Pagination],
                slidesPerView: 1,
                spaceBetween: 12,
                pagination: {
                    el: ".block-ecommerce-benefits .swiper-pagination",
                },
            })
        })
    }

    let video = $('.block-ecommerce-benefits video')[0]

    if(video) {
        video.pause()
    }

    let timeline = gsap.timeline({
          scrollTrigger: {
              trigger: '.block-ecommerce-benefits .block-col-right',
              start: 'top 70%',
              end: '40% top',
              scrub: 0.05,
              onEnter: () => {
                if(video) {
                    video.currentTime = 0
                    video.play()
                }
              },
              onEnterBack: () => {
                if(video) { video.play() }
              },
              onLeave: () => {
                if(video) { video.pause() }
              },
              onLeaveBack: () => {
                  if(video) { video.pause() }
              },
              //markers: true,
              //toggleActions: 'resume pause reverse pause'
          }
      }
    )

    timeline.fromTo('.block-ecommerce-benefits .video-shape', { y: 0 }, { y: -50, duration: 0.25, ease: Power2.easeOut }, 0)

}

initBlock()

